import type { NewUserQuizCopy } from '../types';

export const RU_NEW_USER_QUIZ_COPY = {
  booking: {
    backToVideo: 'Назад к видео',
    bookedSnackbar: 'Демо забронировано — до встречи!',
    bullets: {
      pricing: 'Прозрачная цена с учётом объёма и уровня поддержки',
      teams: 'Для команд: ревьюеры, глоссарии и единая библиотека',
      setup: 'Подберите оптимальную конфигурацию для вашего контента и процессов',
    },
    confirmation: {
      title: 'Ваше демо забронировано',
      description:
        'Приглашение на встречу отправлено на вашу электронную почту. Локализованное превью останется доступным для просмотра и отправки до встречи.',
    },
    continue: 'Продолжить',
    decision: {
      bookDemo: {
        title: 'Забронировать демо',
        buttonLabel: 'Забронировать демо',
        description:
          'Разберите со специалистом командные пространства, API и дубляж больших объёмов — и определите место Rask в вашем процессе.',
      },
      exploreEditor: {
        title: 'Продолжить в редакторе',
        buttonLabel: 'Открыть редактор',
        description:
          'Отредактируйте текст, голоса и тайминг самостоятельно. Во время пробного периода доступны все возможности.',
      },
    },
    description: 'Настроим Rask под ваш контент, команду и объёмы.',
    followUp: {
      callAgenda: [
        'Коротко посмотреть созданное вами превью',
        'Обсудить ваш процесс, объёмы и план запуска',
        'Настроить редактор под ваш рабочий процесс',
      ],
      callDescription: 'Подтверждённые дату, время и ссылку на встречу вы найдёте в приглашении.',
      callDurationLabel: (minutes) => `Видеозвонок на ${minutes} мин`,
      callTitle: 'Ваша встреча',
      manageBooking: {
        title: 'Управление встречей',
        buttonLabel: 'Управление встречей',
        closeLabel: 'Закрыть',
        description:
          'Чтобы перенести или отменить встречу, откройте событие в корпоративном календаре и воспользуйтесь действиями в приглашении.',
        googleCalendarLabel: 'Открыть корпоративный Google Calendar',
        outlookCalendarLabel: 'Открыть корпоративный календарь Outlook',
      },
      prepareDescription:
        'Пригласите коллег и отметьте изменения текста, голоса или тайминга, которые хотите обсудить.',
      prepareTitle: 'Подготовьтесь к встрече',
      share: {
        title: 'Поделитесь превью с командой',
        buttonLabel: 'Поделиться',
        copiedButtonLabel: 'Скопировано',
        copyButtonLabel: 'Копировать',
        description: 'Отправьте локализованное превью команде, чтобы коллеги заранее подготовили полезные комментарии.',
        modalDescription: 'Отправьте видео кому угодно с помощью ссылки ниже',
        modalTitle: 'Поделиться видео',
      },
      videoCallLabel: 'Видеозвонок',
    },
    heading: 'Запланируйте встречу по настройке',
    headingSecondLine: '',
    maybeLater: 'Возможно, позже',
    persistenceError: 'Не удалось сохранить этот шаг. Нажмите «Продолжить», чтобы повторить попытку.',
    rating: '4,7 из 5 на G2',
    scheduler: {
      fallbackBookedLabel: 'Встреча забронирована',
      openBookingPage: 'Открыть страницу бронирования',
      loadErrorDescription:
        'Возможно, ваша сеть или регион блокирует встроенный виджет. Откройте страницу бронирования в новой вкладке.',
      loadErrorTitle: 'Не удалось загрузить календарь',
      loadingLabel: 'Загрузка календаря',
    },
    trustedBy: 'Нам доверяют команды по всему миру',
    verificationPending: {
      title: 'Подтверждаем бронирование',
      description: 'Проверяем данные встречи в HubSpot. Это может занять немного времени.',
    },
  },
  controls: {
    back: 'Назад',
    continue: 'Продолжить',
    continueAnyway: 'Всё равно продолжить',
    progress: (currentStep, totalSteps) => `Вопрос ${currentStep} из ${totalSteps}`,
    submitError: 'Не удалось сохранить ваши ответы. Попробуйте ещё раз.',
  },
  priorityQuestion: {
    title: 'Что для вас сейчас в приоритете при локализации?',
    audioTitle: 'Что для вас сейчас в приоритете при локализации?',
    options: {
      collaborate_with_team_or_reviewers: { label: 'Контроль качества и рабочий процесс' },
      consistent_voice_and_terminology: { label: 'Единый голос и терминология' },
      fast_results_no_setup: { label: 'Простая и быстрая самостоятельная работа' },
      integration_into_product_or_workflow: { label: 'Интеграция и соответствие требованиям' },
      not_sure_yet: { label: 'Пока не определились' },
    },
    subtitle: 'Выберите один вариант',
  },
  questions: {
    content_team_size: {
      title: 'Сколько человек в вашей команде работают с видеоконтентом?',
      options: {
        just_me: { label: '1' },
        large_team_5_plus: { label: '8+' },
        small_team_2_5: { label: '2-7' },
      },
    },
    localization_frequency: {
      title: 'Как часто вы локализуете видео?',
      audioTitle: 'Как часто вы локализуете контент?',
      options: {
        continuously: { label: 'У меня постоянная потребность' },
        occasionally_quarterly: { label: 'Иногда' },
        regularly_monthly: { label: 'Регулярно', description: 'Каждый месяц' },
        one_time_project: { label: 'У меня разовая задача' },
      },
    },
  },
} satisfies NewUserQuizCopy;
